angular.module('impactx.productstock').controller('AllProductStockListController', AllProductStockListController);

AllProductStockListController.$inject = ['$scope', '$routeParams', 'dataGen', 'selectedListItems', '$mdDialog',
    'ListHelperService', 'ToastService', 'ProductStockService', '$redirect', 'AppConfiguration'];

function AllProductStockListController($scope, $routeParams, dataGen, selectedListItems, $mdDialog, ListHelperService,
                                       ToastService, ProductStockService, $redirect,AppConfiguration)
{
    var ctrl = this;
    var autoAdjust = AppConfiguration.get("adjustStockForAllSupplierProducts");

    ctrl.editStock = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        var tempScope = {};
        dataGen.getData(tempScope, {ids: selectedListItems.getSelectedIds()}, "/productstock/view/all").then(function () {
            $mdDialog.show({
                templateUrl: "modules/productstock/templates/editallproductstock.tmpl.html",
                controller: "EditAllProductStockController",
                controllerAs: "editAllProductStockController",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    data: tempScope.data,
                    trns: tempScope.trns
                }
            }).then(function () {
                ListHelperService.refreshListData($scope, 'allProductStockListController', {unselectRows: selectedItems});
            }, function () {
                ListHelperService.refreshListData($scope, 'allProductStockListController', {unselectRows: selectedItems});
            });
        });
    };

    ctrl.canEditStock = function() {
        var canEdit = selectedListItems.isMultiSelection();
        if (canEdit) {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                var item = selectedItems[i];
                if (selectedItems[i].noAction && selectedItems[i].noAction.value) {
                    return false;
                }
            }
        }
        return canEdit;
    };

    ctrl.removeOrderStop = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/productstock/orderstop/remove").then(function (data) {
            ListHelperService.refreshListData($scope, 'allProductStockListController', {unselectRows: selectedItems});
            ToastService.openStandardToast(data.trns.saveSuccess);
        })
    };
    ctrl.canRemoveOrderStop = function () {
        var orderStopFound = false;
        if (selectedListItems.isMultiSelection()) {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                var item = selectedItems[i];
                if (selectedItems[i].noAction && selectedItems[i].noAction.value) {
                    return false;
                }
                else if (selectedItems[i].ostSet === "1") {
                    orderStopFound = true;
                }
            }
        }
        return orderStopFound;
    };


    ctrl.canCheckStockAmounts = function () {
        return selectedListItems.isNoSelection() && impactX.isDefined(ctrl, "meta.actions.checkStockAmounts.allowed");
    };

    ctrl.checkStockAmounts = function () {
        dataGen.postAsForm({}, {}, "/productstock/checkstockamounts"); // async call, just start the check in the background.
        ToastService.openStandardToast(ctrl.meta.trns.startedStockAmountsCheck);
    };

    ctrl.canConsolidate = function () {
        return !autoAdjust && selectedListItems.isMultiSelection() &&
            selectedListItems.getSelectedItems().length > 1 &&
            selectedListItems.checkEach(function (item) {
                return !item.consolidated.value;
            });
    };

    ctrl.consolidateStock = function () {
        $redirect.redirectTo(null, "/productstockconsolidate", selectedListItems.getSelectedIds());
    };

    ctrl.canSeparate = function () {
        return !autoAdjust && selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().consolidated.value;
    };

    ctrl.separateStock = function () {
        var data = {
            id: selectedListItems.getFirstSelectedId(),
            dissolveLabel: ctrl.meta.trns.dissolveGroup,
            removeLabel: ctrl.meta.trns.separateOne,
            title: ctrl.meta.trns.separatestock,
        };
        ProductStockService.separateStock(data, ctrl.meta.trns.separated).then(function (response) {
            if (response && response.one) {
                var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
                ListHelperService.refreshListData($scope, 'allProductStockListController', {unselectRows: selectedItems});
            }
        });
    }

    var buttonDefinition = [
        {label: "editstock", action: ctrl.editStock, condition: ctrl.canEditStock, process: 'ManageStockAmounts'},
        {label: "removeOrderStop", action: ctrl.removeOrderStop, condition: ctrl.canRemoveOrderStop, process: 'ManageStockAmounts'},
        {label: "checkStockAmounts", action: ctrl.checkStockAmounts, condition: ctrl.canCheckStockAmounts, process: 'ManageStockAmounts'},
        {label: "consolidatestock", action: ctrl.consolidateStock, condition: ctrl.canConsolidate, process: 'ManageStockAmounts'},
        {label: "separatestock", action: ctrl.separateStock, condition: ctrl.canSeparate, process: 'ManageStockAmounts'},
    ];

    this.meta = {
        rowTemplate: 'modules/productstock/templates/allproductstocklist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/productstock/list/all',
        ctrl: this,
        id: "allproductstock",
        params: {'catId': $routeParams.id},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}